// Copyright (c) 2017 Deere & Company

export default [
    {
        displayName: 'EXPIRES',
        path: ['expireDate']
    },
    {
        displayName: 'STARTS',
        path: ['startDate']
    },
    {
        displayName: 'RESPONSIBLE_DEALER',
        path: ['responsibleAccount', 'account']
    },
    {
        displayName: 'PIN',
        path: ['pin']
    },
    {
        displayName: 'PIP_NUMBER',
        path: ['pipNumber']
    }
];



// WEBPACK FOOTER //
// ./src/pip/shared/constants/pip-products-sort-options.js